import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoResultsComponent {
  @Input() info = $localize`Brak wyników`;
}
